<template>
    <cod-dialog
        :show.sync="showDialog"
        back-icon="fal fa-arrow-left"
        max-width="500px"
    >
        <!-- Header -->
        <div slot="header">
            {{ $t('cash_sales.heading') }}
        </div>

        <!-- Content -->
        <div class="pa-5" slot="content">
            <v-menu
                v-model="picker1"
                :close-on-content-click="false"
                :nudge-right="32"
                transition="scale-transition"
                offset-y
                min-width="290"
            >
                <template #activator="{ on }">
                    <v-text-field
                        v-model="form.date"
                        :error-messages="form.$errors.date"
                        :label="$t('cash_sales.date')"
                        prepend-icon="fal fa-calendar"
                        clear-icon="fal fa-times"
                        clearable
                        readonly
                        v-on="on"
                        @blur="form.validate('date')"
                        @input="delete form.$errors.date"
                    />
                </template>
                <v-date-picker
                    v-model="form.date"
                    :max="moment().format('YYYY-MM-DD')"
                    @input="picker1 = false; form.validate('date')"
                />
            </v-menu>

            <v-menu
                v-model="picker2"
                :close-on-content-click="false"
                :nudge-right="32"
                transition="scale-transition"
                offset-y
                min-width="290"
            >
                <template #activator="{ on }">
                    <v-text-field
                        v-model="form.paid_at_date"
                        :error-messages="form.$errors.paid_at_date"
                        :label="$t('cash_sales.paid_at_date')"
                        prepend-icon="fal fa-calendar"
                        clear-icon="fal fa-times"
                        clearable
                        readonly
                        v-on="on"
                        @blur="form.validate('paid_at_date')"
                        @input="delete form.$errors.paid_at_date"
                    />
                </template>
                <v-date-picker
                    v-model="form.paid_at_date"
                    :max="moment().format('YYYY-MM-DD')"
                    @input="picker1 = false; form.validate('paid_at_date')"
                />
            </v-menu>

            <number-field
                v-model="form.amount"
                :error-messages="form.$errors.amount"
                :label="$t('cash_sales.amount')"
                :precision="2"
                @blur="form.validate('amount')"
                @input="delete form.$errors.amount"
            />
        </div>

        <template slot="footer">
            <v-btn
                class="flex-1 mr-1"
                outlined
                color="primary"
                @click="showDialog = false"
            >
                {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
                class="flex-1 ml-1"
                color="primary"
                depressed
                :disabled="form.$busy"
                :loading="form.$busy"
                @click="save()"
            >
                {{ $t('general.save') }}
            </v-btn>
        </template>
    </cod-dialog>
</template>

<script>
import ApiService from '@/services/ApiService';
import CodDialog from '@/components/CodDialog';
import CashSale from '@/models/CashSale';
import NumberField from '@/components/NumberField';
import { required } from 'vuelidate/lib/validators';

export default {
    components: {
        CodDialog,
        NumberField
    },

    props: {
        show: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            showDialog: false,
            form: this.createForm(),

            picker1: null,
            picker2: null
        }
    },

    validations: {
        form: {
            date: { required },
            paid_at_date: { required },
            amount: { required },
        }
    },

    watch: {
        show(val) {
            this.showDialog = val;
            this.form = this.createForm();
        },

        showDialog(val) {
            this.$emit('update:show', val);
        },
    },

    methods: {
        createForm() {
            return new Form(this, 'form', {
                id: this.item?.id || null,
                user_id: this.user?.id || null,
                date: this.item?.date
                    ? moment(this.item.date).format('YYYY-MM-DD')
                    : moment().format('YYYY-MM-DD'),
                paid_at_date: this.item?.paid_at_date
                    ? moment(this.item.date).format('YYYY-MM-DD')
                    : moment().format('YYYY-MM-DD'),
                amount: this.item?.amount || null,
            });
        },

        async save() {
            if(!this.form.validate()) return;

            const method = !this.form.id ? 'post' : 'patch';
            const url = '/admin/cash-sales' + (this.form.id ? `/${this.form.id}` : '');
            const response = await ApiService[method](url, this.form)

            this.showDialog = false;
            this.$emit('save', new CashSale(response.data))
            this.$snackbar(this.$t('cash_sales.saved'), 'success');
        },
    }
};
</script>

<style lang="scss" scoped>
</style>
